import React, { useContext, useEffect, useReducer, useState } from "react";
import styles from "./Step.module.css";
import StepsHeader from "../../../Components/StepsHeader/StepsHeader";
import PropertyAddress from "../../../assets/componentAssets/PropertyAddress.svg";
import info from "../../../assets/componentAssets/info.svg";
import defaultImage from "../../../assets/componentAssets/defaultImage.svg";
import { InputAdornment, TextField } from "@mui/material";
import { reducer } from "../consumptionReducer";
import CustomInput from "../../../Components/CustomInput/CustomInput";
import { formStep6 } from "../../../Utility/utils";
import { form6State } from "../InitialState/form6State";
import BuildingData from "../../../Components/BuildingData/BuildingData";
import UpdatedFile from "../../../Components/Greenox/UpdatedFile/UpdatedFile";
import NavButton from "./NavButton";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import {
  DeleteApi,
  PatchApi,
  base_url,
  getApi,
} from "../../../Utility/network";
import UploadImage from "../../../Components/UploadImage/UploadImage";
import deleteIcion from "../../../assets/componentAssets/deleteIcon.png";
import axios from "axios";
import DownloadIcon from "@mui/icons-material/Download";

import PopUpInfo from "../../../Components/PopUpInfo/PopUpInfo";
function Step6() {
  const { state: contextState, setState } = useContext(AppContext);

  const { stepLanguage, language } = contextState;
  const [data, setData] = useState({ name: "sample", size: "20kb" });
  const [addError, setAddError] = useState({});
  const [image, setImage] = useState();
  const [buildingImg, setBuildingImg] = useState([]);
  const style = { width: "100%" };
  const [add, setAdd] = useState({ street: "", postcode: null, location: "" });
  const [response, setResponse] = useState(false);
  const [pop, setPop] = useState(false);
  const [infoText, setInfoText] = useState([]);
  const [state, dispatch] = useReducer(reducer, form6State);
  const [disableNext, setDisableNext] = useState(true);
  const downLoadImg = async (image) => {
    try {
      const response = await fetch(image, { mode: "cors" });
      if (!response.ok) throw new Error("Failed to fetch image.");

      const blob = await response.blob();

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = image.split("/").pop() || "downloaded-image";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error downloading image:", error.message);
    }
  };

  const handleChange = (name, value) => {
    setAdd((prev) => ({ ...prev, [name]: value }));

    setAddError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  useEffect(() => {
    setTimeout(() => {
      setDisableNext(false);
    }, 3000);
  });
  useEffect(() => {
    const { info, buildingData } = contextState.otherData;
    if (info) {
      setAdd((prev) => {
        let postcode = prev.postcode
          ? prev?.postcode
          : info?.postcode
          ? info?.postcode
          : buildingData?.postal_code;
        return { ...prev, ...info, postcode }; // Correct syntax
      });
    }
  }, [contextState.otherData]);
  useEffect(() => {
    getData();
    window.scroll(0, 0);
  }, []);
  useEffect(() => {
    if (isFiveDigitNumberFlexible(add.postcode)) {
      getPin(add.postcode);
    }
  }, [add.postcode]);

  function isFiveDigitNumberFlexible(input) {
    const numStr = String(input);
    return /^\d{5}$/.test(numStr);
  }

  const getPin = async (_pin) => {
    try {
      const responseData = await getApi(
        `/energy_consumption/postode_city/?postcode=${_pin}`
      );
      if (responseData && responseData.data.data.length > 0) {
        const firstObj = responseData.data.data[0];
        setAdd((prev) => ({
          ...prev,
          ...(firstObj?.state && { location: firstObj?.state }),
        }));
      } else {
        // setAdd((prev) => ({ ...prev, location: "" }));
      }
    } catch (error) {}
  };
  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;

    if (!add.street) {
      formIsValid = false;
      errors["street"] = `${stepLanguage.street_error}`;
    }
    const pincodeRegex = /^\d{3,5}$/;
    if (!add.postcode) {
      formIsValid = false;
      errors["postcode"] = `${stepLanguage.postcode_error}`;
    } else if (!pincodeRegex.test(add.postcode)) {
      formIsValid = false;
      errors["postcode"] = `${stepLanguage.post_val}`;
    }
    if (!add.location) {
      formIsValid = false;
      errors["location"] = `${stepLanguage.location_error}`;
    }

    setAddError(errors);
    return formIsValid;
  };

  const handleSubmit = async (num, type) => {
    try {
      if (type === "next") {
        if (!handleValidation()) {
          return;
        }

        try {
          const postData = await PatchApi(
            `/energy_consumption/form/${contextState.form_id}/`,
            { address: [add], language: language === "de" ? 2 : 1 }
          );
          if (postData.status === 200 || postData.status === 201) {
            setState((prev) => ({
              ...prev,
              filledPage:
                prev.filledPage >= prev.page + 1
                  ? prev.filledPage
                  : prev.page + 1,
              page: prev.page + 1,
              otherData: {
                ...prev.otherData,
                info: add,
              },
            }));
            // setState((prev) => ({ ...prev, page: prev.page + 1 }));
          } else {
            throw Error("api failed");
          }
        } catch (error) {
          alert(error);
        }
      } else if (type === "prev") {
        setState((prev) => ({ ...prev, page: prev.page - 1 }));
      } else if (type === "save") {
        await getApi(
          `/energy_consumption/form/${contextState.form_id}/generate_link`
        );
        setResponse(true);

        // navigate("/login");
      }
    } catch (error) {
      alert("something went wrong");
    }
  };

  useEffect(() => {
    if (image) {
      uploadImageApi();
    }
  }, [image]);

  const uploadImageApi = () => {
    const formData = new FormData();
    formData.append("image", image);
    const axiosConfig = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    axios
      .patch(
        `${base_url}/energy_consumption/form/${contextState.form_id}/upload_building_photos/`,
        formData,
        axiosConfig
      )
      .then((response) => {
        setImage();
        getData();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getData = async () => {
    try {
      const response = await getApi(
        `/energy_consumption/form/${contextState.form_id}/`
      );
      setBuildingImg(response.data.data.building_images);
    } catch (error) {}
  };
  const DeleteImages = async (id) => {
    try {
      const response = await DeleteApi(`energy_consumption/building/${id}/`);
      getData();
      // setBuildingImg(response.data.data.building_images);
    } catch (error) {}
  };
  const handleDeleteImg = (id) => {
    DeleteImages(id);
  };
  const address = {
    number: [
      {
        heading: stepLanguage.number_h,
        para1: stepLanguage.number_d1,
        para2: stepLanguage.number_d2,
      },
    ],
    Postcode: [
      {
        heading: stepLanguage.Postcode_h,
        para1: stepLanguage.Postcode_d1,
        para2: stepLanguage.Postcode_d2,
      },
    ],
    Location: [
      {
        heading: stepLanguage.Location_h,
        para1: stepLanguage.Location_d1,
        para2: stepLanguage.Location_d2,
      },
    ],
    photo: [
      {
        heading: stepLanguage.build_photo,
        para1: stepLanguage.build_photo_info,
        // para2: stepLanguage.Location_d2,
      },
    ],
  };
  const handlePopUp = (data) => {
    setPop(true);
    setInfoText(data);
  };
  return (
    <div>
      <div className={styles.con}>
        <StepsHeader
          image={PropertyAddress}
          heading={contextState?.headerLanguage?.property_address}
          secPara={stepLanguage.Please_provide_proper_information}
        />
        <div className={styles.fieldDetails}>
          <div className={styles.fieldCom}>
            <div className={styles.fields}>
              <CustomInput
                key={1}
                label={stepLanguage.house_number}
                name="street"
                value={add.street}
                onChange={handleChange}
                options={[]}
                error={!!addError.street}
                helperText={addError.street}
                popData={address?.number}
              />
            </div>
            <div className={styles.fields}>
              <CustomInput
                key={1}
                label={stepLanguage.postcode}
                name="postcode"
                value={add.postcode}
                onChange={handleChange}
                options={[]}
                error={!!addError.postcode}
                helperText={addError.postcode}
                popData={address?.Postcode}
                type="number"
              />
            </div>
            <div className={styles.fields}>
              <CustomInput
                key={1}
                label={stepLanguage.location}
                name="location"
                value={add.location}
                onChange={handleChange}
                options={[]}
                error={!!addError.location}
                helperText={addError.location}
                popData={address?.Location}
              />
            </div>
          </div>
          <div>
            <p className={styles.fieldName}>
              {stepLanguage.upload_building_photo}
              <img
                src={info}
                style={{ cursor: "pointer" }}
                onClick={() => handlePopUp(address?.photo)}
              />
            </p>
            <UploadImage getImage={setImage} imgs={image} />
            <div style={{ marginTop: "20px" }}>
              {buildingImg.map((item) => {
                const filename = item.image.split("/").pop();
                return (
                  <div
                    style={{
                      background: "#AFDB2826",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                    className={styles.imageContainer}
                  >
                    <div>
                      <div>
                        <img
                          src={item.image}
                          style={{ marginRight: "15px", width: "80px" }}
                        />
                      </div>
                      <div>{filename}</div>
                    </div>

                    <div
                      style={{
                        padding: "10px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        onClick={() => downLoadImg(item.image)}
                        style={{ paddingTop: "10px" }}
                      >
                        <DownloadIcon />
                      </div>
                      <img
                        src={deleteIcion}
                        onClick={() => {
                          handleDeleteImg(item?.id);
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <NavButton
        handleSubmit={handleSubmit}
        response={response}
        setResponse={setResponse}
        disabled={disableNext}
      />
      {pop && (
        <PopUpInfo
          handleClose={() => setPop(false)}
          open={pop}
          data={infoText}
        />
      )}
    </div>
  );
}

export default Step6;
